import { Service } from '@/services/Service';
import { RelatedCompaniesService } from '@/services/relations/related-companies.service';
import { PersonsService } from '@/services/persons.service';
import relations from '@/services/relations/relations.service';

class PersonRelatedCompaniesService extends Service {
  static entity(personId) {
    return `${PersonsService.entity}/${personId}/${RelatedCompaniesService.entity}`;
  }
}

Object.assign(PersonRelatedCompaniesService, relations);

export default PersonRelatedCompaniesService;
